module.exports = __webpack_public_path__ + "media/images/home/focus-chinese-dining-logo-d0d2c74388152d97b3e6c50ea110fbbc.png";